<template>
<div v-if="ready">
    <div ref="source">
        <table style="border: 1px solid lightgrey; border-radius: 5px; padding: 25px;" :class="$style.sourceTable">
            <thead>
                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'RÉSUMÉ DU PROFIL DU PATIENT' : 'SUMMARY OF PATIENT PROFILE'}}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'Profil du patient' : 'Patient Profile'}}
                    </th>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Âge' : 'Age'}}
                    </td>
                    <td>
                       
                        <span v-if="questionMap[2].value[1][1]">{{questionMap[2].value[1][1]}}</span>                 

                       
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Sexe' : 'Gender'}}
                    </td>
                    <td>
                        
                         <span v-if="questionMap[3].value[1]">{{questionMap[3].configMap[1].inputs[questionMap[3].value[1]].label[$language()]}}</span>                                    
                    </td>
                </tr>
                 <tr>
                    <td>
                        {{$language()=='fr' ? 'Tension artérielle dans les valeurs cibles' : 'Blood pressure in target range'}}
                    </td>
                    <td>
                        <span v-if="questionMap[4].value[1]" v-html="questionMap[4].configMap[1].inputs[questionMap[4].value[1]].label[$language()]" />
                                       
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$language()=='fr' ? 'Taux de C-LDL dans les valeurs cibles ' : 'LDL-C in target range '}}
                    </td>
                    <td>
                        <span v-if="questionMap[5].value[1]" v-html="questionMap[5].configMap[1].inputs[questionMap[5].value[1]].label[$language()]" />              
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Statut tabagique' : 'Smoking status '}}
                    </td>
                    <td>
                        <span v-if="questionMap[6].value[1]">{{questionMap[6].configMap[1].inputs[questionMap[6].value[1]].label[$language()]}}</span>                
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$language()=='fr' ? 'Antécédents familiaux de maladie cardiovasculaire prématurée' : 'Family history of premature CVD '}}
                    </td>
                    <td>
                    <span v-if="questionMap[7].value[1] && questionMap[7].value[1][0]==1" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][0]].label[$language()]"/> 
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][1]==1" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][1]].label[$language()]"/> 
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][2]==1" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][2]].label[$language()]"/>
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][3]==1" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][3]].label[$language()]"/>
                    <span v-else>N/A</span>

                    </td>
                </tr>

                 <tr>
                    <td>
                        {{$language()=='fr' ? 'Obésité' : 'Obesity'}}
                    </td>
                    <td>
                    <span v-if="questionMap[7].value[1] && questionMap[7].value[1][0]==2" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][0]].label[$language()]"/> 
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][1]==2" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][1]].label[$language()]"/> 
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][2]==2" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][2]].label[$language()]"/>
                    <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][3]==2" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][3]].label[$language()]"/>
                    <span v-else>N/A</span>

                    </td>
                </tr>
                <tr>
                    <td>
                        {{$language()=='fr' ? 'Complication microvasculaire du diabète' : 'Microvascular diabetic complication '}}
                    </td>
                    <td>
                         <span v-if="questionMap[7].value[1] && questionMap[7].value[1][0]==3" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][0]].label[$language()]" />
                         <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][1]==3" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][1]].label[$language()]" />
                         <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][2]==3" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][2]].label[$language()]" />
                         <span v-else-if="questionMap[7].value[1] && questionMap[7].value[1][3]==3" v-html="questionMap[7].configMap[1].inputs[questionMap[7].value[1][3]].label[$language()]" />
                        <span v-else>N/A</span>                

                    </td>
                </tr>


               
                <tr>
                    <td>
                        {{$language()=='fr' ? 'Durée du diabète de type 2' : 'Type 2 diabetes duration'}}
                    </td>
                    <td>
                          <span v-if="questionMap[8].value[1]" v-html="questionMap[8].configMap[1].inputs[questionMap[8].value[1]].label[$language()]"/>
                                          
                    </td>
                </tr>

                <tr>
                    <td>
                        <que v-if="$language()=='fr'">Taux cible d’HbA<sub>1C</sub></que>
                        <que v-else>A1C target</que>
                    </td>
                    <td>
                        <span v-if="questionMap[9].value[1]">{{questionMap[9].configMap[1].inputs[questionMap[9].value[1]].label[$language()]}}</span>
                    </td>
                </tr>

                 <tr>
                    <td>
                        <que v-if="$language()=='fr'">Taux d’HbA<sub>1C</sub></que>
                        <que v-else>A1C</que>
                    </td>
                    <td>
                           <span v-if="questionMap[10].value[1][1]">{{questionMap[10].value[1][1]}}%</span>               
                    </td>
                </tr>

                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'Renseignements thérapeutiques' : 'Treatment Information'}}
                    </th>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Types d’antihyperglycémiants actuels ' : 'Current antihyperglycemic agent classes  '}}
                    </td>
                    <td>
                        <ul>
                            <template v-for="(selected,index) in q11_selections">
                                <li :key="'q11_index_'+index" v-html="selected"/>
                            </template>                
                        </ul>                
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Traitements hypolipidémiant et antihypertenseurs actuels' : 'Current dyslipidemia and antihypertensive medication(s)'}}
                    </td>
                    <td>
                         <ul>
                            <template v-for="(selected,index) in q12_selections">
                                <li :key="'q12_index_'+index" v-html="selected"/>
                            </template>                
                        </ul>                      
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <center>
        <v-btn small color="primary" v-if="!download" @click="download=!download" style="margin: 25px;">
            <str :index="'button > download'"/>
        </v-btn>
    </center>
    
    <pdf v-if="download" :filename="'patient_summary'" :htmlCode="htmlCode()" @close="download=false"/>
</div>
</template>

<script>
import pdf from '@/components/Print/Print.vue';

export default {
    props: {
        questionMap: {
            type: Object,
            required: true
        }
    },
    components: {
        pdf
    },
    created: function(){
        var self = this;
        setTimeout(function(){
            self.ready = true;
        },1000)
    },
    data: function(){
        return {
            ready: false,
            download: false
        }
    },
    methods: {
        htmlCode: function(){
            var source = this.$refs.source;
            return source.innerHTML;
        }
    },
    computed: {
         q11_selections: function(){
            var question = this.questionMap[11];
            var inputMap = {};
            for(let i in question.config.groups[0].inputs){
                let input = question.config.groups[0].inputs[i];
                inputMap[input.id] = input.label[this.$language()];
            }

            var selections = [];
            if(question && question.value[1] && question.value[1].length>0){
                for(let i=0; i<question.value[1].length; i++){
                    let value = question.value[1][i];
                    selections.push(inputMap[value]);
                }
            }
            return selections;
        },
         q12_selections: function(){
            var question = this.questionMap[12];
            var inputMap = {};
            for(let i in question.config.groups[0].inputs){
                let input = question.config.groups[0].inputs[i];
                inputMap[input.id] = input.label[this.$language()];
            }

            var selections = [];
            if(question && question.value[1] && question.value[1].length>0){
                for(let i=0; i<question.value[1].length; i++){
                    let value = question.value[1][i];
                    selections.push(inputMap[value]);
                }
            }
            return selections;
        }
    }
}
</script>

<style module>
.sourceTable {
    margin: 0 auto;
    width: 100%;
    max-width: 1024px;
    border-collapse: collapse;
}

.sourceTable th, .sourceTable td {
    vertical-align: top;
    border: 1px solid black;
    padding: 0.5rem;
}

.sourceTable th {
    background-color: #00a4c0;
    color: white;
    font-size: 20px;
    font-weight: 300;
    padding: 1.5% 0;
}

.sourceTable tr td:first-child {
    color: black;
    font-weight: 500;
}
</style>

